import React from 'react';

/**
 * FeedStack — right-column news/evidence/transcript feeds.
 * Turn 1 placeholder-lite: uses episode.transcript + crew queues as the
 * data source. Turn 2 will wire this to the real Wire/Scribe backends.
 */
export default function FeedStack({ episode, crew }) {
  const wire = crew.find((c) => c.name === 'wire');
  const scribe = crew.find((c) => c.name === 'scribe');

  const breakingItems = [];
  if (wire?.queue_depth > 0) {
    breakingItems.push({ src: 'WIRE', headline: `${wire.queue_depth} topic candidate${wire.queue_depth > 1 ? 's' : ''} awaiting review`, meta: wire.last_action_at || '' });
  }
  if (scribe?.queue_depth > 0) {
    breakingItems.push({ src: 'SCRIBE', headline: `${scribe.queue_depth} item${scribe.queue_depth > 1 ? 's' : ''} under verification hold`, meta: scribe.last_action_at || '' });
  }
  if (breakingItems.length === 0) {
    breakingItems.push({ src: 'STUDIO', headline: 'No breaking items · newsroom idle', meta: '' });
  }

  const transcript = episode?.segments || episode?.transcript || [];

  return (
    <div className="feed-stack" data-testid="feed-stack">
      <section className="feed-section" data-testid="feed-breaking">
        <div className="feed-section-head">
          <span className="t breaking"><i className="dot" />Breaking</span>
          <span style={{ fontSize: 10, color: 'var(--studio-text-3)', letterSpacing: '0.14em' }}>WIRE · SCRIBE</span>
        </div>
        {breakingItems.map((it, idx) => (
          <div className="feed-item" key={idx} data-testid={`feed-breaking-${idx}`}>
            <div className="src">{it.src}</div>
            <div className="headline">{it.headline}</div>
            {it.meta && <div className="meta">{new Date(it.meta).toLocaleTimeString('en-US', { hour12: false })}</div>}
          </div>
        ))}
      </section>

      <section className="feed-section" data-testid="feed-trending">
        <div className="feed-section-head">
          <span className="t trending"><i className="dot" />Trending</span>
          <span style={{ fontSize: 10, color: 'var(--studio-text-3)', letterSpacing: '0.14em' }}>TURN 2 WIRE</span>
        </div>
        <div className="feed-item">
          <div className="src">STUDIO</div>
          <div className="headline" style={{ color: 'var(--studio-text-2)' }}>Trending cluster wiring ships next turn with Wire backend</div>
        </div>
      </section>

      <section className="feed-section" data-testid="feed-transcript">
        <div className="feed-section-head">
          <span className="t top"><i className="dot" />Transcript</span>
          <span style={{ fontSize: 10, color: 'var(--studio-text-3)', letterSpacing: '0.14em' }}>{transcript.length} lines</span>
        </div>
        {transcript.slice(0, 8).map((t, idx) => (
          <div className="feed-item" key={idx} data-testid={`feed-transcript-${idx}`}>
            <div className="src">{(t.speaker || 'host').toString().toUpperCase()}</div>
            <div className="headline">{(t.text || t.line || '').slice(0, 140)}</div>
          </div>
        ))}
        {transcript.length === 0 && (
          <div className="feed-item"><div className="src">STENO</div>
            <div className="headline" style={{ color: 'var(--studio-text-2)' }}>Transcript empty · generate an episode to populate</div>
          </div>
        )}
      </section>

      <section className="feed-section" data-testid="feed-verified">
        <div className="feed-section-head">
          <span className="t verified"><i className="dot" />Verified Evidence</span>
        </div>
        <div className="feed-item">
          <div className="src">SCRIBE</div>
          <div className="headline" style={{ color: 'var(--studio-text-2)' }}>Evidence packet wiring ships turn 2 with Scribe verification</div>
        </div>
      </section>
    </div>
  );
}
